'use client';
import useProductComparison from '@/app/_hooks/useProductComparison';
import Link from 'next/link';
import { useState } from 'react';
import { useEffect } from 'react';

export default function SpAddToCompare({ productSlug }) {
  const { selectedProducts, addToComparison, removeFromComparison } =
    useProductComparison();
  const [isProductInComparison, setIsProductInComparision] = useState(false);

  useEffect(() => {
    setIsProductInComparision(
      selectedProducts.some(
        (selectedProduct) => selectedProduct === productSlug
      )
    );
  });

  const onChange = (e) => {
    if (e.target.checked && !isProductInComparison) {
      addToComparison(productSlug);
    } else {
      removeFromComparison(productSlug);
    }
  };

  return (
    <div className="inline-flex mb-4 md:mb-0 text-sm  text-color-primary bg-primary-5 items-center border border-primary-400 p-2 rounded-md md:mt-4">
      <input
        id="add_to_compare"
        className="border-color-primary border rounded-sm "
        type="checkbox"
        onChange={onChange}
        checked={isProductInComparison}
      />

      {isProductInComparison ? (
        <div>
          <Link href="/compare" className="pr-2">
            مشاهده صفحه مقایسه
          </Link>
        </div>
      ) : (
        <div for="add_to_compare" className="pr-2">
          مقایسه محصول
        </div>
      )}
    </div>
  );
}
